<template>
  <div>
    <!--1.头部-->
    <header-frame></header-frame>

    <!--3.一级导航-->
    <first-menu></first-menu>

    <div class="wrap">
      <div v-html="lawData"></div>
    </div>

    <!--10.footer-->
    <footer-frame></footer-frame>
  </div>
</template>

<script>
import HeaderFrame from '@/components/Header';
import FirstMenu from '@/components/FirstMenu';
import FooterFrame from '@/components/Footer';

export default {
  components: {
    HeaderFrame,
    FirstMenu,
    FooterFrame,
  },
  data() {
    return {
      lawData: null,
    };
  },
  mounted() {
    this.getLaw();
  },
  methods: {
    getLaw() {
      let replacement = {
        menuID: 827,
      };

      this.$api.getArticleDetail(replacement).then((res) => {
        this.lawData = res.contentH;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.wrap {
  margin-bottom: calc-width(30vw);
  padding: 0 calc-width(20vw);
  /*max-width: calc(100% - calc-width(40vw));*/
}
</style>



// WEBPACK FOOTER //
// src/pages/content/Law.vue